import { css } from '@emotion/core';
import { variables, mq } from '../../../cssInJs';

const numberOfTiles = [1, 2, 3, 4]
//const marginLR = [14, 14, 14, 14]
const marginTB = [14, 14, 14, 14]

const widthPercent = (index) => 100 / numberOfTiles[index] + '%'

// const linkText = {
//   color: variables.fontColor,
//   fontSize: '0.8rem',
//   padding: '0 20px',
//   '&:hover': {
//     color: variables.fontColor,
//   }
// }

export const tileListStyle = {
  tiles: mq({
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    //marginLeft: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    //marginRight: [-marginLR[0] / 2, -marginLR[1] / 2, -marginLR[2] / 2, -marginLR[3] / 2],
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth:['960px'],
    margin: 'auto'
  }),
  categoryList : mq({
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth:['960px'],
    margin: 'auto',
    'div.ff.form-group' : {
      maxWidth: '250px'
    }
  })
}

export const tileStyle = {
  tile: mq({
    //paddingLeft: [marginLR[0] / 2, marginLR[1] / 2, marginLR[2] / 2, marginLR[3] / 2],
    //paddingRight: [marginLR[0] / 2, marginLR[1] / 2, marginLR[2] / 2, marginLR[3] / 2],
    paddingLeft : '10px',
    paddingRight : '10px',
    paddingTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    paddingBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth: [widthPercent(0), widthPercent(1), widthPercent(2), widthPercent(3)],
    flexBasis: [widthPercent(0), widthPercent(1), widthPercent(2), widthPercent(3)],
    flexGrow: 0,
    flexShrink: 0
  }),
  tileSlider: mq({
    maxWidth:['100%', null, '240px'],
    margin:'auto'
  }),
  tileLink: {
    background: '#fff',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    //padding: 5,
    //border: '1px solid red',
    '&:hover': {
      textDecoration: 'none'
      //background: '#f3f3f3'
    }
  },
  prdImage: {
    //padding: '0 5px',
    //maxWidth: '190px',
    //margin: 'auto',
    //width: '100%',
    //backgroundColor: variables.lightGreyColor
    backgroundColor: 'transparent'
  },
  bg: mq({
    //height: 0,
    //paddingBottom: '100%',
    backgroundPosition: 'center top',
    backgroundSize: ['contain', null, 'cover'],
    backgroundRepeat: 'no-repeat',
    paddingTop: ['335px', null, '210px']
  }),
  shortDes : css({
    textAlign:'center',
    marginTop: '0.8rem'
  }),
  // name: css(linkText, {
  //   fontWeight: 'bold',
  //   textAlign:'center',
  //   marginBottom:'8px',
  //   lineHeight:'1',
  // }),
  name : mq({ 
    color: variables.fontColor,
    padding: '0 20px',
    fontWeight: 'bold',
    textAlign:'center',
    marginBottom:'8px',
    marginTop:'8px',
    lineHeight:'1',
    fontSize:['1.6rem', null, '0.8rem'],
    '&:hover': {
      color: variables.fontColor,
    }
  }),
  // price: css(linkText, {
  //   marginTop: 'auto',
  //   textAlign:'center',
  //   marginBottom:'1rem',
    
  // })
  price : mq({
    padding: '0 20px',
    color: variables.fontColor,
    marginTop: 'auto',
    textAlign:'center',
    marginBottom:['3rem', null, '1rem'],
    fontSize: ['1.5rem', null, '1rem'],
    '&:hover': {
      color: variables.fontColor,
    }
  })

}